import Subtitle from "@/components/Subtitle";
import BasicText from "@/components/BasicText";
import Title from "@/components/Title";
import Image from "@/components/Image";

import polygon from "@/assets/images/node-about-us.svg";

const About: React.FC = () => {
  const achievements = [
    { title: "TVL", info: "500M+" },
    { title: "MARKETCAP", info: "5,14M+" },
    { title: "HOLDERS", info: "1,000+" },
    { title: "INVESTORS", info: "50+" },
  ];
  return (
    <div className="flex flex-col gap-10 lg:gap-0 justify-center lg:justify-normal lg:flex-row py-20 items-center lg:items-center">
      <div className="flex flex-col flex-1">
        <div className="px-20 mt-10">
          <Subtitle>// SOME INFORMATION ABOUT US</Subtitle>
          <Title className="mt-4">
            Lorem ipsum dolor sit amet consectetur.
          </Title>
          <BasicText className="mt-6" size="18px" color="faded">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Est
            nesciunt voluptates libero blanditiis unde sapiente eius ullam
            reiciendis quaerat odio!
          </BasicText>
        </div>
      </div>
      <div className="flex-1 relative">
        <div className="grid grid-cols-2 px-[80px] py-[40px] justify-items-center items-center relative z-20 w-[531px] h-[248px] gap-x-[120px]">
          {achievements.map((element) => {
            return (
              <div className="w-full">
                <div className="flex flex-col p4 flex-1 justify-start items-start">
                  <div className="text-[#878794] sm:text-[14px] font-light">{element.title}</div>
                  <div className="flex items-center">
                    <div className="size-[8px] bg-luminode-blue"></div>
                    <div className="text-white sm:text-[32px] ml-8 font-extralight font-geist-mono">{element.info}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <Image src={polygon} alt="polygon" className="absolute top-0 w-[531px] z-10" />
      </div>
    </div>
  );
};

export default About;
